import { allRunContracts, type RunContractKind } from './runContracts';

export type DailyChallenge = {
  id: string;
  seed: number;
  contractKind: RunContractKind;
  title: string;
  subtitle: string;
};

function fnv1a(text: string): number {
  let hash = 0x811c9dc5;
  for (let i = 0; i < text.length; i++) {
    hash ^= text.charCodeAt(i);
    hash = Math.imul(hash, 0x01000193);
  }
  return hash >>> 0;
}

function todayId(now = new Date()): string {
  return now.toISOString().slice(0, 10);
}

export function getDailyChallenge(now = new Date()): DailyChallenge {
  const id = todayId(now);
  const seed = fnv1a(`last-mile-daily:${id}`);
  const contracts = allRunContracts();
  const contract = contracts[seed % contracts.length]!;
  return {
    id,
    seed,
    contractKind: contract.kind,
    title: 'Daily Blacksite',
    subtitle: `${contract.title} · Seed ${seed.toString(16).toUpperCase().padStart(8, '0')}`,
  };
}
